import { useState } from "react";
import { Eye, EyeOff } from "lucide-react";
import { Input } from "../ui/input";
import { Label } from "../ui/label";

export const PasswordInput = ({ id, testid, value, onChange, autoComplete = "current-password", label = "Password" }) => {
  const [show, setShow] = useState(false);
  return (
    <div className="space-y-1.5">
      <Label htmlFor={id}>{label}</Label>
      <div className="relative">
        <Input
          id={id}
          data-testid={testid}
          type={show ? "text" : "password"}
          required
          autoComplete={autoComplete}
          value={value}
          onChange={(e) => onChange(e.target.value)}
          className="h-12 rounded-full bg-white pr-12"
        />
        <button
          type="button"
          data-testid={`${testid}-toggle`}
          onClick={() => setShow((s) => !s)}
          aria-label={show ? "Hide password" : "Show password"}
          className="absolute right-3 top-1/2 -translate-y-1/2 rounded-full p-1.5 text-[#6b6b73] transition-colors hover:text-[#1f1f24]"
        >
          {show ? <EyeOff className="h-4 w-4" /> : <Eye className="h-4 w-4" />}
        </button>
      </div>
    </div>
  );
};

export const EmailInput = ({ value, onChange, testid = "login-email-input" }) => (
  <div className="space-y-1.5">
    <Label htmlFor="login-email">Email</Label>
    <Input
      id="login-email"
      data-testid={testid}
      type="email"
      required
      autoComplete="email"
      placeholder="you@example.com"
      value={value}
      onChange={(e) => onChange(e.target.value)}
      className="h-12 rounded-full bg-white"
    />
  </div>
);

export const FormError = ({ text }) =>
  text ? (
    <p data-testid="login-error" role="alert" className="rounded-2xl bg-[#fff1ec] px-4 py-3 text-sm font-medium text-[#a63c12]">
      {text}
    </p>
  ) : null;
